import classNames from 'classnames';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import Button from '../Controls/ButtonComponent/Button';
import Icon from '../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { IMessageModalOption } from '~/view/containers/Messages';
import './style.scss';

interface Props {
  title?: string;
  message?: string;
  closeModal?: () => void;
  options?: IMessageModalOption[];
  minWidth?: number;
  maxWidth?: number;
  wrapperClassName?: string;
  titleClassName?: string;
  iconClassName?: string;
  isLoading?: boolean;
}

export default class ModalMessage extends React.PureComponent<Props, {}> {
  onButtonPress = (cb: undefined | (() => void)) => () => {
    if (cb) cb();
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  };

  render() {
    return (
      <div
        className={classNames('d-flex flex-column full-width', this.props.wrapperClassName)}
        style={{ minWidth: this.props.minWidth || 'initial', maxWidth: this.props.maxWidth || 'initial' }}
      >
        <div className="pt-3 pb-4 px-3  d-flex flex-column align-items-center modal-message">
          {this.props.isLoading ? (
            <div className="d-flex flex-column ">
              <Skeleton className="my-2 d-block ml-auto mr-auto" width={200} height={30} />
              <Skeleton className="mb-2" width={350} height={80} />
            </div>
          ) : (
            <>
              {this.props.title ? <p className="modal-message-title color-dark text-size-20 family-bold">{this.props.title}</p> : null}
              {this.props.title && this.props.message ? <div className="mb-4"></div> : null}
              {this.props.message ? <p className="modal-message-description">{this.props.message}</p> : null}
            </>
          )}
        </div>
        <div className="d-flex flex-row full-width justify-content-between gap-10">
          {this.props.options?.map((option, idx) => (
            <Button
              key={idx}
              title={option.title}
              onClick={this.onButtonPress(option.onPress)}
              disabled={option.disabled}
              loading={option.loading}
              appearance={option.appearance}
              stretched
              className={option.className}
              titleClassName={option.titleClassName}
            />
          ))}
        </div>

        <Icon
          name={Icons.Close}
          size={14}
          onPress={this.props.closeModal}
          className={classNames('modal-message-close border-gray2', this.props.iconClassName)}
        />
      </div>
    );
  }
}
